

export const userData = [
  {
    name: "Jan",
    activeUser: 4,
    performance: 10

  },
  {
    name: "Fab",
    activeUser: 21,
    performance: 5
  }, {
    name: "Mar",
    activeUser: 15,
    performance: 11
  }, {
    name: "Apr",
    activeUser: 8,
    performance: 20
  }, {
    name: "May",
    activeUser: 40,
    performance: 14
  }, {
    name: "Jun",
    activeUser: 38,
    performance: 28
  }, {
    name: "July",
    activeUser: 45,
    performance: 23
  }, {
    name: "Aug",
    activeUser: 30,
    performance: 17
  }, {
    name: "Sep",
    activeUser: 35,
    performance: 18
  }, {
    name: "Oct",
    activeUser: 40,
    performance: 14
  }, {
    name: "Nov",
    activeUser: 37,
    performance: 13
  }, {
    name: "Dec",
    activeUser: 28,
    performance: 7
  },
];

export const productData = [
  {
    name: "Jan",
    "Sales": 4000,
  },
  {
    name: "Feb",
    "Sales": 3000,
  },
  {
    name: "Mar",
    "Sales": 5000,
  },
];

export const userRows = [
 
  {
    id:0,
    nom:"Admin",
    prenom: "Super",
    pseudo:"SuperAdmin",
    email: "superAdmin@gmail.com",
    img:"https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
type:"admin",

    abonnement:"Oui",
  

  }
 ,
  {
    id:1,
    nom:"Ahmed",
    prenom: "Yessine",
    pseudo:"Yessinos",
    email: "bestclic@gmail.com",
    img:"https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    type:"",
    date_Naiss:"19/12/1998",
    date_Inscrit: "23/01/2023",
    code_pp:"af0h98km",
    code_pr:"af0h98km",
    abonnement:"Oui",
    note:"20"

  },
  {
    id:2,
    nom:"Ali",
    prenom: "Messoud",
    pseudo:"Aloulou",
    email: "AliMes@gmail.com",
    img:"https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    type:"",
    date_Naiss:"19/12/1993",
    date_Inscrit: "23/01/2022",
    code_pp:"af0h45Lm",
    code_pr:"af0h45Lm",
    abonnement:"Non",
    note:"30"

  }, {
    id:3,
    nom:"Anas",
    prenom: "Zilan",
    pseudo:"Anouss",
    email: "anasZ@gmail.com",
    img:"https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    type:"",
    date_Naiss:"9/12/1999",
    date_Inscrit: "23/03/2023",
    code_pp:"af0g75qm",
    code_pr:"af0g75qm",
    abonnement:"Oui",
    note:"50"
  }, {
    id:4,
    nom:"Zayne",
    prenom: "kamel",
    pseudo:"zinos",
    img:"https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    type:"",
    email: "zinK@gmail.com",
    date_Naiss:"9/2/1994",
    date_Inscrit: "23/01/2020",
    code_pp:"af0a49pm",
    code_pr:"af0a49pm",
    abonnement:"Oui",
    note:"20"

  }, {
    id:5,
    nom:"Maryem",
    prenom: "Nour",
    pseudo:"Marroum",
    email: "MarroumN@gmail.com",
    img:"https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    type:"",
    date_Naiss:"01/01/1999",
    date_Inscrit: "4/03/2023",
    code_pp:"af0s36vm",
    code_pr:"af0s36vm",
    abonnement:"Non",
    note:"30"
  }
  
];

export const productRows = [
  {
    id: 1,
    nom: "Promo_catch",
    img:
      "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    
    code_pp: "ffovh0k45lm",
    nbr_user:"5",
    price: "$20",
    user_id:"USovh0k45lm",
    user_name:"Ahmed",
  },
  {
    id: 2,
    nom: "Promo_cc",
    img:
      "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    
    code_pp: "ffovh1m98lm",
    price: "$30",
    
    user_id:"USovh0k45fd",
    user_name:"Ali",
  }, {
    id: 3,
    nom: "Promo_tch",
    img:
      "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    
    code_pp: "ffnb7lk45lm",
    price: "$60",
    user_id:"USovh0k45nv",
    user_name:"Mariem",
  }, {
    id: 4,
    nom: "Promo_ch",
    img:
      "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    
    code_pp: "ffovh0k60lm",
    price: "$20",
    user_id:"USovh0k45xw",
    user_name:"Anis",
  },
  {
    id: 5,
    nom: "Promo_catch",
    img:
      "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    
    code_pp: "ffovx9k45lm",
    price: "$10",
    user_id:"USovh0k45yy",
    user_name:"Youcef",
  },
];